import api from '../../api/nodeBackApi';

export const getProcessedDailyIAData = async (camIdentifier, customerIdParam, { day, month, year }) => {
  try {
    const response = await api.post(`/api/dataAnalyzed/getDailyData/${camIdentifier}/`, {
      day, month, year, customerId: customerIdParam
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching processed IA data:', error);
    throw error;
  }
};

export const getProcessedRangeIAData = async (camIdentifier, customerIdParam, { startDay, endDay, month, year }) => {
  try {
    const response = await api.post(`/api/dataAnalyzed/getWeeklyData/${camIdentifier}/`, {
      startDay, endDay, month, year, customerId: customerIdParam
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching processed range IA data:', error);
    throw error;
  }
};

export const getSignedImageUrl = async (s3Key, bucket = '') => {
  try {
    const response = await api.get(`/api/dataAnalyzed/signUrl`, {
      params: { key: s3Key, bucket: bucket }
    });
    return response.data.url; 
  } catch (error) {
    console.error("Error en getSignedImageUrl:", error);
    throw error;
  }
};
